"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Tooltip = _interopRequireDefault(require("@eig-builder/core-ui/Tooltip"));

var helpers = _interopRequireWildcard(require("./right-view-helpers"));

var _styles = require("@eig-builder/core-ui/styles");

var _dataGridContext = require("../../../data-grid-context");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    active: {
      backgroundColor: "rgba(0,0,0,0.08)"
    },
    rightviewBtn: {
      display: "inline-block",
      "& .icon": {
        color: "$primitive-text-secondary !important",
        verticalAlign: "baseline"
      },
      "&:hover": {
        "& .icon": {
          color: "$primitive-text-primary !important"
        },
        backgroundColor: "$navbar-active-background-color",
        cursor: "pointer"
      }
    }
  };
});

var RightViewSelector = function RightViewSelector(props) {
  var tooltip = props.tooltip,
      isRightViewActive = props.isRightViewActive,
      hasRightView = props.hasRightView,
      allCategories = props.allCategories,
      selectedCategories = props.selectedCategories;

  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      categoryFilters = _useDataGridContext.categoryFilters,
      setCategoryFilters = _useDataGridContext.setCategoryFilters;

  (0, _react.useEffect)(function () {
    if (isRightViewActive) {
      var newCategoryFilter = helpers.getFilterFromCategories(allCategories, selectedCategories);

      if (Array.isArray(categoryFilters)) {
        var globalFiltersWithoutOldCategoryFilter = categoryFilters.filter(function (f) {
          return f.filterType !== 'right-view-selector';
        });
        setCategoryFilters([newCategoryFilter].concat((0, _toConsumableArray2["default"])(globalFiltersWithoutOldCategoryFilter)));
      } else if (categoryFilters) {
        setCategoryFilters([newCategoryFilter, categoryFilters]);
      } else {
        setCategoryFilters([newCategoryFilter]);
      }
    } else {
      var globalFiltersWithoutCategories = helpers.getFiltersWithoutCategories(categoryFilters);
      setCategoryFilters(globalFiltersWithoutCategories);
    }
  }, [allCategories, selectedCategories, isRightViewActive]);
  var rightViewTag = 'right-view-button-' + props.tag;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip.text,
    placement: "top",
    className: "".concat(classes.rightviewBtn, " ").concat(isRightViewActive ? classes.active : "")
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: hasRightView,
    tag: rightViewTag,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: rightViewTag,
    dataElementId: rightViewTag
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "icon",
    icon: "storage",
    tag: 'right-view-icon-' + props.tag
  }))));
};

RightViewSelector.propTypes = {
  tag: _propTypes["default"].string,
  tooltip: _propTypes["default"].object,
  isRightViewActive: _propTypes["default"].bool,
  hasRightView: _propTypes["default"].func,
  allCategories: _propTypes["default"].array,
  selectedCategories: _propTypes["default"].array
};
var _default = RightViewSelector;
exports["default"] = _default;